import m from "../../geodata/es2015/germanyHigh";
window.am4geodata_germanyHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/germanyHigh.js
// module id = null
// module chunks = 